var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.667 490.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M369.92,21.333L128,263.253V384h120.747l241.92-241.92L369.92,21.333z M231.04,341.333h-60.373V280.96L369.92,81.707 l60.373,60.373L231.04,341.333z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "384,320 384,426.667 42.667,426.667 42.667,128 192,128 234.667,85.333 0,85.333 0,469.333 426.667,469.333 426.667,277.333 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5f5ef670760f67c697373ced76d7a813.svg";
export { ForwardRef as ReactComponent };